import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import PlaceholderImage from './_PlaceholderImage';
import PreloadedImage from './_PreloadedImage';
import OptimizedImage from './_OptimizedImage';
import { availableRatios } from './pic.settings.js';
import throttle from 'jsTools/throttle';


var PicComponent = React.createClass({
  displayName: 'PicComponent',
  propTypes: {
    id: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    altText: PropTypes.string,
    ratios: PropTypes.array.isRequired,
    preload: PropTypes.bool.isRequired,
    size: PropTypes.string.isRequired,
    className: PropTypes.string,
    imageClass: PropTypes.string,
    children: PropTypes.node,
    imgixSettings: PropTypes.object
  },
  getInitialState() {
    return {
      currentRatio: this.props.ratios[0]
    };
  },
  componentDidMount() {
    this._startScrollListener();
    this._updateImage();
    this._startResizeListener();
  },
  componentWillUnmount() {
    this._stopScrollListener();
    this._stopResizeListener();
  },
  _startScrollListener() {
    window.addEventListener('scroll', this._handleScrollThrottled());
  },
  _stopScrollListener() {
    window.removeEventListener('scroll', this._handleScrollThrottled());
  },
  _handleScrollThrottled() {
    if (!this.throttledScroll) {
      this.throttledScroll = throttle(this._onScroll, 200).bind(this);
    }
    return this.throttledScroll;
  },
  _onScroll() {
    this._updateImage();
  },
  _startResizeListener() {
    window.addEventListener('resize', this._handleResizeThrottled());
  },
  _stopResizeListener() {
    window.removeEventListener('resize', this._handleResizeThrottled());
  },
  _handleResizeThrottled() {
    if (!this.throttledResize) {
      this.throttledResize = throttle(this._onResize, 500).bind(this);
    }
    return this.throttledResize;
  },
  _onResize() {
    this._startScrollListener();
    this._updateImage();
  },
  _isArtDirected() {
    return this.props.ratios.length > 1;
  },
  _updateImage() {
    if (this._shouldImageUpdate()) {
      this._stopScrollListener();
      const currentRatio = this._getCurrentRatio();
      const optimizedWidth = this._getOptimizedWidth(currentRatio);
      this.setState({
        optimize: true,
        optimizedWidth,
        currentRatio
      });
    }
  },
  _shouldImageUpdate() {
    return this._isVisible();
  },
  _isVisible() { // Higher prio on REALLY visible elements?
    var domnode = this.pictureNode;
    if (!domnode) {
      return false;
    }

    var dims = domnode.getBoundingClientRect();
    var h = window.innerHeight;
    var w = window.innerWidth;

    // add some height to load images offscreen
    if (w < 600) { // mobile
      h = h * 3;
    } else {
      h = h * 2;
    }
    // and some width
    w = w * 2;
    // are we vertically visible?
    var topVisible = dims.top > 0 && dims.top < h;
    var bottomVisible = dims.bottom > 0 && dims.bottom < h;
    var verticallyVisible = topVisible || bottomVisible;
    // also, are we horizontally visible?
    var leftVisible = dims.left > 0 && dims.left < w;
    var rightVisible = dims.right > 0 && dims.right < w;
    var horizontallyVisible = leftVisible || rightVisible;
    // we're only visible if both of those are true.
    var visible = horizontallyVisible && verticallyVisible;
    return visible;
  },
  _getCurrentRatio() {
    var ratio = this.props.ratios[0];
    if (this._isArtDirected() && this.picRatioNode) {
      var cssRatio = window.getComputedStyle(this.picRatioNode, ':after').content;
      for (var ratioInConfig in availableRatios) {
        if (cssRatio.indexOf(ratioInConfig) > -1) {
          ratio = ratioInConfig;
          break;
        }
      }
    }
    return ratio;
  },
  _getOptimizedWidth(ratio) {
    var clientWidth = this.pictureNode && this.pictureNode.clientWidth || 0;
    var dpr = this._getDevicePixelRatio();
    var width = this._getWidthFromConfig(ratio, clientWidth * dpr);
    const preloadedWidth = this._getPreloadedWidth(ratio);
    width = Math.max(width, preloadedWidth);
    // save width to avoid downsizing of images
    this._setPreloadedWidth(ratio, width);
    return width;
  },
  _getDevicePixelRatio() {
    var clientDPR = (window && window.devicePixelRatio) || 1;
    if (clientDPR > 2) {
      clientDPR = 2;
    }
    return clientDPR;
  },
  _getWidthFromConfig(ratio, desiredWidth) {
    var widths = availableRatios[ratio].widths;
    var i = 0;
    var width;
    for (i; i < widths.length; ++i) {
      width = widths[i];
      if (width >= desiredWidth || i === (widths.length - 1)) {
        return width;
      }
    }
    return widths[0];
  },
  _setPreloadedWidth(ratio, width) {
    if (!this._preloads) {
      this._preloads = {};
    }
    this._preloads[ratio] = width;
  },
  _getPreloadedWidth(ratio) {
    return this._preloads && this._preloads[ratio] || 0;
  },
  _onOptimizedLoaded() {
    this.setState({
      optimizedLoaded: true
    });
  },
  _preloadImages(ratios) {
    return ratios.map(ratio => <PreloadedImage {...this.props} ratio={ratio} key={ratio} ref="preloaded" onPreloaded={this._setPreloadedWidth}/>);
  },
  _noscriptImage(ratios) {
    return <noscript className="pic__noreact-fallback" key="noscript" dangerouslySetInnerHTML={{__html: ReactDOMServer.renderToStaticMarkup(<div>{this._preloadImages(ratios)}</div>) }} />; // eslint-disable-line react/no-danger
  },
  _getRatioComponent() {
    if (this._isArtDirected()) {
      return (
        <div className="pic__ratio"
          ref={(node) => { this.picRatioNode = node; }}
          style={{position: 'absolute', visibility: 'hidden'}} >
        </div>
      );
    }
  },
  render() {
    const { children, className, preload, imageClass, ratios, ...other } = this.props;
    const { optimize, optimizedWidth, currentRatio, optimizedLoaded } = this.state;
    const potentionalRatioComponent = this._getRatioComponent();
    var image;
    if (optimize) {
      image = [<OptimizedImage {...this.props} ratio={currentRatio} key={currentRatio} width={optimizedWidth} onLoad={this._onOptimizedLoaded} optimizedLoaded={optimizedLoaded} />];
    } else {
      image = [
        <PlaceholderImage imageClass={imageClass} key={currentRatio}/>
      ];
      if (!preload) {
        image.push(this._noscriptImage(ratios));
      }
    }
    if (preload && !optimizedLoaded) {
      image.unshift(this._preloadImages(ratios));
    }
    const style = require('./Pic.scss');
    return (
      <figure {...other} className={className}>
        <div className={'pic pic--' + currentRatio} ref={(node) => {
          this.pictureNode = node;
        }}>
          {image}
        </div>
        {potentionalRatioComponent}
        {children}
      </figure>
    );
  }
});

export default PicComponent;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Pic/_PicComponent.js
 **/